import analytics from '@/Analytics';
import { toPascalCase } from '@/Utils/StringUtility.js';
import { analyticsPluginName } from '@/Utils/AnalyticsUtility';

const overlayTrackingProviderNames = [analyticsPluginName.clarity];

// Vue 3 wrapper components with no meaningful name for analytics — skip during ancestor walk.
const GENERIC_WRAPPER_NAMES = new Set([
    'Transition', 'TransitionGroup', 'KeepAlive', 'Suspense',
    'BaseTransition', 'AsyncComponentWrapper', 'Fragment',
]);

function getComponentName(instance) {
    return instance?.$options?.name || instance?.$?.type?.name || null;
}

function findTrackableAncestorName(componentInstance) {
    let current = componentInstance?.$parent;
    while (current) {
        const name = getComponentName(current);
        if (name && !GENERIC_WRAPPER_NAMES.has(name)) {
            return name;
        }
        current = current.$parent;
    }
    return null;
}

function normalizeName(name) {
    if (!name) return null;
    return toPascalCase(name.split('.').pop());
}

export function trackOverlayEvent({ componentInstance, overlayType, action, componentName, title }) {
    const resolvedName = componentName || normalizeName(findTrackableAncestorName(componentInstance));

    if (!resolvedName) return;

    const payload = { component_name: resolvedName };
    if (title) payload[`${overlayType}_title`] = title;

    analytics.trackTo(overlayTrackingProviderNames, `${overlayType}_${action}`, payload);
}
